import React, { useEffect, useRef, useState } from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types';
import StepsLoader from "../steps-loader";
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepFooterAction from "../../base-components/step-footer-action";
import getStep from '../../../helpers/getStep';

const JoinReasonOther = ({ _step_service, error, step_ID, step_URL, next_step, step_form, setDataToContext, getDataFromContext }) => {

    const form = useRef()
    const data = getDataFromContext(step_ID)
    const [isLoading, setIsLoading] = useState(false)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
   
    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, "join_reason_other", value)
    }

    useEffect(()=> {
        setIsValid(isValidForm())
        
    }, [inputData])

    useEffect(() => {
        getStep(["join_reason_other"]).then(res => {
            setInputData({...res})
    
        })

                          if (window.PageBus) {
                    window.PageBus.publish("analyticsServices", {
pageID: "onboarding",
stepSeq: "2",
stepName: "financial info:other purpose of pro account",
flowType: "sales",
flowName: "onboarding",
productName: "onboarding",
trackMethod: "flow"
                    }
                );
            }
    }, [])

    const action = () => {
        _step_service({ step_ID, setIsLoading, next_step: "/id-card"})
    }

    const isValidForm = () => {
       return [...form.current.elements].every(element => {
            return element.value !== "" && element.value !== " "
        })
    }
    return (
            <StepsLoader step_ID={step_ID} loading={isLoading}>
                <form ref={form}>
                    <BaseParagraph>
                    <h3>{t('financial_infos.financial_info_purpose_of_pro_account_specif_other.title')}</h3>
                        <InputField
                            label={t('financial_infos.financial_info_purpose_of_pro_account_specif_other.label')}
                            value={inputData["join_reason_other"] !== "NULL" && inputData["join_reason_other"]}
                            name={"join_reason_other"}
                            getInputValue={getInputValue}
                            key={"join_reason_other"}
                        error={error}
                            max={200}
                        
                        />
               
                    </BaseParagraph>
                </form>
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} />
            </StepsLoader>
    )
}

JoinReasonOther.propTypes = {
    error: PropTypes.array,
    _step_service: PropTypes.func,
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
}

export default JoinReasonOther